import React, { useState, useRef, useEffect } from 'react';
import { Input, Dropdown, Menu } from 'antd';
import { api, apis, apiHolder, } from 'api';
import SiriusRadio from '@web-common/components/UI/SiriusRadio';
import ErrorIcon from '@web-common/components/UI/Icons/svgs/ErrorSvg';
import { useActions, useAppSelector } from '@web-common/state/createStore';
import { actions as LoginActions } from '@web-common/state/reducer/loginReducer';
import mobileList from '@web-common/components/util/mobileArea';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { ProductProtocols } from '@web-common/utils/constant';
import styles from './moblie.module.scss';
import { getIn18Text } from 'api';
import { jumpToRedirectUrl, safeDecodeURIComponent } from '@web-common/utils/utils';
import { useMount, useMemoizedFn } from 'ahooks';
import initNECaptchaWithFallback from './yidun-captcha.js';
const loginApi = api.requireLogicalApi(apis.loginApiImpl);
const accountApi = api.requireLogicalApi(apis.accountApiImpl);
const registerApi = api.requireLogicalApi(apis.registerApiImpl);
const performanceApi = api.requireLogicalApi(apis.performanceImpl);
const systemApi = api.getSystemApi();
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const isWebWmEntry = systemApi.isWebWmEntry();
const pattern = /^\d*$/;
const areaPattern = /^1\d{10}$/;
const codePattern = /^\d{6}$/;
const MobileAreaDropdown = props => {
    const { onSelect } = props;
    const [current, setCurrent] = useState('86');
    const [areaVisible, setAreaVisible] = useState(false);
    const onSwitch = (areaNumber) => {
        setCurrent(areaNumber);
        setAreaVisible(false);
        onSelect && onSelect(areaNumber);
    };
    const menuItem = (item) => (React.createElement(Menu.Item, { key: item.prefix, className: styles.menuItem, onClick: () => onSwitch(item.prefix) },
        React.createElement("span", { className: item.prefix === current ? 'blue' : '' }, item.name),
        React.createElement("span", { className: item.prefix === current ? 'blue' : '' }, '+' + item.prefix)));
    const menu = (React.createElement(Menu, null, mobileList.map(item => {
        if (item.title) {
            return (React.createElement(Menu.ItemGroup, { key: item.title, className: styles.menuGroup, title: item.title }, item.children.map(area => menuItem(area))));
        }
        return menuItem(item);
    })));
    return (React.createElement(Dropdown, { overlay: menu, getPopupContainer: node => node.parentElement || document.body, overlayClassName: styles.mobileAreaWrap, trigger: ['click'], onVisibleChange: (visible) => {
            setAreaVisible(visible);
        } },
        React.createElement("div", { className: styles.mobileAreaTxt },
            React.createElement("span", null, '+' + current),
            React.createElement("i", { className: `dark-invert ${areaVisible ? styles.arrowUp : styles.arrowDown}` }))));
};
export const MobileValidateForm = props => {
    const { defaultValue = '', defaultArea, hideMobileInput, showProtocol = true, onSubmit, onPreLogin, onSendCode, submitTxt, toRegister, loadingTxt = '', disable = false, renderSubmitBottom, from, } = props;
    const reSendTime = 60;
    const inputRef = useRef(null);
    const [mobileArea, setMobileArea] = useState(defaultArea || '86');
    const [phone, setPhone] = useState(defaultValue);
    const [mobile, setMobile] = useState('');
    const [code, setCode] = useState('');
    const [errorTxt, setErrorTxt] = useState('');
    const [codeTime, setCodeTime] = useState(reSendTime);
    const [interValTimer, setInterValTimer] = useState();
    const [protocolChecked, setProtocolChecked] = useState(true);
    const [loading, setLoading] = useState(false);
    const captchaIns = useRef(null);
    const [validate, setValidate] = useState('');
    const [captchaLoaded, setCaptchaLoaded] = useState(false);
    const checkPhone = () => (mobileArea === '86' && !areaPattern.test(phone)) || !pattern.test(phone);
    const submit = async () => {
        if (loading || disable) {
            return;
        }
        if (!phone) {
            setErrorTxt(getIn18Text('QINGWANSHANNINDE11'));
            return;
        }
        if (checkPhone()) {
            setErrorTxt(getIn18Text('QINGSHURUZHENGQUE'));
            return;
        }
        if (!code) {
            setErrorTxt(getIn18Text('QINGSHURUYANZHENG'));
            return;
        }
        if (!codePattern.test(code)) {
            setErrorTxt(getIn18Text('QINGSHURU6WEI11'));
            return;
        }
        if (!protocolChecked) {
            const t = (React.createElement("span", { className: styles.uProtocol, onClick: e => e.stopPropagation() },
                React.createElement("span", null, getIn18Text('QINGXIANTONGYI')),
                React.createElement("a", { href: ProductProtocols.agreement, target: "_blank", rel: "noreferrer" }, getIn18Text('FUWUTIAOKUAN')),
                React.createElement("span", null, getIn18Text('HE')),
                React.createElement("a", { href: ProductProtocols.privacy, target: "_blank", rel: "noreferrer" }, getIn18Text('YINSIZHENGCE'))));
            SiriusModal.error({
                title: t,
                okText: getIn18Text('ZHIDAOLE'),
                centered: true,
                hideCancel: true,
            });
            return;
        }
        performanceApi.time({ statKey: 'login', statSubKey: 'mobile_code' }).then();
        setLoading(true);
        const errMsg = await onSubmit(mobile, code);
        setLoading(false);
        performanceApi
            .point({
            statKey: 'login_ev',
            statSubKey: 'mobile_code_failed',
            value: 1,
            valueType: 4,
            flushAndReportImmediate: true,
        })
            .then();
        setErrorTxt(errMsg);
    };
    const onPhoneBlur = () => {
        if (phone) {
            if (pattern.test(phone)) {
                onPreLogin(mobile);
            }
            else {
                setErrorTxt(getIn18Text('QINGSHURUZHENGQUE'));
            }
        }
    };
    const sendCodeHandler = useMemoizedFn(async () => {
        setCodeTime(reSendTime - 1);
        const timer = window.setInterval(() => {
            setCodeTime(time => {
                if (time < 1) {
                    clearInterval(timer);
                    return reSendTime;
                }
                return time - 1;
            });
        }, 1000);
        setInterValTimer(timer);
        console.warn('[bind mobile] mobile', mobile, mobileArea, phone);
        const errorMsg = await onSendCode(mobile);
        if (errorMsg) {
            setErrorTxt(errorMsg);
            clearInterval(timer);
            setInterValTimer(undefined);
            setCodeTime(reSendTime);
        }
        if (captchaIns.current) {
            captchaIns.current.refresh();
            setValidate('');
        }
    });
    const sendCode = async () => {
        if (!phone) {
            return;
        }
        if (checkPhone()) {
            setErrorTxt(getIn18Text('QINGSHURUZHENGQUE'));
            return;
        }
        if (!hideMobileInput) {
            const res = await onPreLogin(mobile);
            if (typeof res === 'string') {
                setErrorTxt(res);
                return;
            }
            if (typeof res === 'object' && res.errmsg) {
                setErrorTxt(res.errmsg);
                return;
            }
        }
        if (!captchaLoaded && from === 'register') {
            setErrorTxt(getIn18Text('WANGLUOBUTONGCHANGQIGNSHAODENG'));
            return;
        }
        if (validate || from !== 'register') {
            await sendCodeHandler();
        }
        else {
            captchaIns.current && captchaIns.current.verify();
        }
    };
    const initNECaptcha = useMemoizedFn(() => {
        initNECaptchaWithFallback({
            captchaId: '2e95e41aa7b041ebbd57071dee39b51e',
            width: '300px',
            mode: 'popup',
            apiVersion: 2,
            errorFallbackCount: 2,
            popupStyles: {
                position: 'absolute',
                top: '20%',
            },
            onVerify: async function (err, data) {
                if (err)
                    return;
                setValidate(data.validate);
                if (data.isFallback) {
                    setCaptchaLoaded(true);
                    return;
                }
                await sendCodeHandler();
            },
        }, function onload(instance) {
            captchaIns.current = instance;
            setCaptchaLoaded(true);
        }, function onerror(err) {
            console.log('[error]', err.code, err.message);
        });
    });
    useEffect(() => {
        var _a;
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus({
            cursor: 'end',
        });
        return () => {
            interValTimer && clearInterval(interValTimer);
        };
    }, []);
    useEffect(() => {
        setMobile(`(${mobileArea})${phone}`);
    }, [phone, mobileArea]);
    useMount(() => {
        initNECaptcha();
    });
    return (React.createElement("div", { className: styles.wrap },
        React.createElement("div", { className: styles.mobileControl, "data-test-id": 'login-mobile' + (from ? '-' + from : '') + '-input' }, hideMobileInput ? (React.createElement("div", { className: styles.defaultMobile }, `当前手机号：${defaultValue}`)) : (React.createElement(React.Fragment, null,
            React.createElement(MobileAreaDropdown, { onSelect: setMobileArea }),
            React.createElement(Input, { placeholder: getIn18Text('QINGSHURUNINDE11'), allowClear: true, className: styles.mobileInput, value: phone, ref: inputRef, maxLength: 11, onChange: e => {
                    const { value } = e.target;
                    const reg = /^\d*$/;
                    if (reg.test(value)) {
                        setPhone(value);
                    }
                }, onBlur: onPhoneBlur, onFocus: () => {
                    setErrorTxt('');
                }, autoComplete: "off" })))),
        React.createElement("div", { className: styles.codeControl },
            React.createElement(Input, { "data-test-id": 'login-authcode' + (from ? '-' + from : '') + '-input', allowClear: true, className: styles.codeInput, maxLength: 6, placeholder: getIn18Text('QINGSHURU6WEI'), value: code, onFocus: () => {
                    setErrorTxt('');
                }, onChange: e => {
                    const { value } = e.target;
                    const reg = /^\d*$/;
                    if (reg.test(value)) {
                        setCode(value);
                    }
                } }),
            React.createElement("div", { className: styles.codeTime, "data-test-id": 'login-authcode' + (from ? '-' + from : '') + '-btn' }, codeTime < reSendTime ? (`${codeTime}s后重试`) : (React.createElement("span", { className: phone ? 'blue' : styles.disabled, onClick: sendCode }, getIn18Text('HUOQUYANZHENGMA'))))),
        React.createElement("div", { hidden: !showProtocol, className: styles.protocolWrap, onClick: e => {
                setProtocolChecked(checked => !checked);
                e.stopPropagation();
            } },
            React.createElement(SiriusRadio, { checked: protocolChecked, "data-test-id": 'login-protocol' + (from ? '-' + from : '') + '-check' },
                React.createElement("span", { className: styles.uProtocol, onClick: e => e.stopPropagation() },
                    React.createElement("span", null, getIn18Text('WOYIYUEDUBING')),
                    React.createElement("a", { href: ProductProtocols.agreement, target: "_blank", rel: "noreferrer" }, getIn18Text('FUWUTIAOKUAN')),
                    React.createElement("span", null, getIn18Text('HE')),
                    React.createElement("a", { href: ProductProtocols.privacy, target: "_blank", rel: "noreferrer" }, getIn18Text('YINSIZHENGCE'))))),
        React.createElement("div", { className: styles.submitBtn, onClick: submit, "data-test-id": 'login-mobile' + (from ? '-' + from : '') + '-submit' }, loading && loadingTxt ? loadingTxt : submitTxt + (loading ? getIn18Text('ZHONG...') : '')),
        renderSubmitBottom
            ? renderSubmitBottom()
            : toRegister && (React.createElement("div", { className: styles.toRegister },
                React.createElement("span", null, getIn18Text('HAIMEIYOUTUANDUI')),
                React.createElement("span", { className: styles.blue, onClick: toRegister }, getIn18Text('LIJIZHUCE')))),
        React.createElement("div", { className: styles.errorWrap, hidden: !errorTxt },
            React.createElement(ErrorIcon, { width: 14, height: 14, className: styles.errorIcon }),
            React.createElement("span", { className: styles.errorText }, errorTxt))));
};
const MobileValidate = props => {
    const { registerSuccess, goLoginNoConfirm } = useAppSelector(state => state.loginReducer);
    const { setMobileBindAccountListInfo, setVisibleSwitchModal, setRegisterInfo, setGoLoginNoConfirm, setRegisterSuccess } = useActions(LoginActions);
    const { from, onSuccess, isBind, isUpdate, toRegister, defaultMobile, hideMobileInput, defaultArea, renderSubmitBottom, type, onShowDeviceRegister } = props;
    const submitTxtMap = {
        register: getIn18Text('XIAYIBU'),
        newRegister: registerSuccess ? getIn18Text('ZHUCE') + getIn18Text('CHENGGONG') : goLoginNoConfirm ? getIn18Text('CHULIZHONG') : getIn18Text('LIJIZHUCE'),
        login: getIn18Text('DENGLU'),
        account: getIn18Text('YANZHENG'),
        loginAccount: getIn18Text('YANZHENG'),
    };
    useEffect(() => {
        if (from === 'register') {
            trackApi.track('pc_register_mobile_code_page');
        }
    }, []);
    const mobileLogin = async (lastLoginAccount) => {
        const { pass, errmsg, showDeviceReport, showMailMasterDownload } = await loginApi.doMobileTokenLogin({
            domain: lastLoginAccount.domain,
            token: lastLoginAccount.token,
            account_name: lastLoginAccount.accountName,
        });
        if (showDeviceReport) {
            onShowDeviceRegister && onShowDeviceRegister();
            return;
        }
        if (showMailMasterDownload) {
            SiriusModal.error({
                content: getIn18Text('UPDATE_TO_MM'),
                maskClosable: false,
                okText: getIn18Text('DOWNLOAD_NOW'),
                onOk: () => {
                    loginApi.doOpenMailMasterDownloadPage();
                },
            });
            return;
        }
        if (pass) {
            performanceApi.timeEnd({ statKey: 'login', statSubKey: 'mobile_code' }).then();
            await performanceApi.saveLog();
            if (!type || type === 'common') {
                if (/(?:^|\?|&)(?:redirectUrl|redirect_url)=([^&#]+)/.test(location.search)) {
                    const url = safeDecodeURIComponent(RegExp.$1);
                    jumpToRedirectUrl(url);
                    return '';
                }
            }
            window.location.assign('/');
            return '';
        }
        performanceApi.timeEnd({ statKey: 'login', statSubKey: 'mobile_code' }, true).then();
        return errmsg;
    };
    const onSubmit = async (mobile, code) => {
        console.log('submit');
        if (from === 'register') {
            const { success, message, data, isRegister, domain, adminAccount } = await registerApi.doValidateCode({
                mobile,
                code,
                source: isWebWmEntry ? 'waimao_web' : undefined,
            });
            console.log('doValidateCode');
            if (!success) {
                setGoLoginNoConfirm(false);
                setRegisterSuccess(false);
                trackApi.track('pc_bind_email_account_page_result', { pageSource: from, actionResult: 'error', result: message });
                return message || '';
            }
            if (isRegister && data) {
                if (data.length) {
                    setMobileBindAccountListInfo({
                        accountList: data,
                        from: 'register',
                        visibleList: true,
                        visibleAccount: false,
                    });
                    trackApi.track('pc_bind_email_account_page_result', { pageSource: from, actionResult: 'mobile_login_select' });
                }
                else {
                    trackApi.track('pc_bind_email_account_page_result', { pageSource: from, actionResult: 'mobile_login_has_registered' });
                    return getIn18Text('MEIGESHOUJIHAO');
                }
            }
            else if (isWebWmEntry) {
                const domainPrefix = domain ? domain.split('.')[0] : '';
                if (!domainPrefix || !adminAccount) {
                    setGoLoginNoConfirm(false);
                    setRegisterSuccess(false);
                    return getIn18Text('WANGLUOQINGQIUCHAO11');
                }
                setRegisterInfo({
                    mobile,
                    code,
                    domainPrefix: domainPrefix,
                    adminAccount: adminAccount,
                    registerTime: new Date().getTime(),
                });
                setGoLoginNoConfirm(true);
            }
            else {
                setRegisterInfo({
                    mobile,
                    code,
                    isValidate: true,
                    visible: true,
                });
                trackApi.track('pc_bind_email_account_page_result', { pageSource: from, actionResult: 'mobile_login_no_account' });
            }
        }
        if (from === 'login') {
            const { success, message, data } = await loginApi.doMobileVerifyCode(code);
            if (!success) {
                trackApi.track('pc_bind_email_account_page_result', { pageSource: from, actionResult: 'error', result: message });
                return message || '';
            }
            if (data === null || data === void 0 ? void 0 : data.length) {
                const loginAccount = data;
                if (loginAccount.length === 1) {
                    if (loginAccount[0].token) {
                        const result = await mobileLogin(loginAccount[0]);
                        trackApi.track('pc_bind_email_account_page_result', { pageSource: from, actionResult: 'mobile_login_enter', result });
                        return result;
                    }
                }
                trackApi.track('pc_bind_email_account_page_result', { pageSource: from, actionResult: 'mobile_login_select' });
                setMobileBindAccountListInfo({
                    accountList: data,
                    from: 'login',
                    visibleList: true,
                });
            }
            else {
                setRegisterInfo({
                    mobile,
                    code,
                    isValidate: true,
                });
                setVisibleSwitchModal(true);
                trackApi.track('pc_bind_email_account_page_result', { pageSource: from, actionResult: 'mobile_login_no_account' });
            }
        }
        if (from === 'account') {
            const promise = isBind
                ? accountApi.doBindMobile.bind(accountApi)
                : isUpdate
                    ? accountApi.doUpdateBindMobile.bind(accountApi)
                    : accountApi.doUnBindMobile.bind(accountApi);
            const { success, message } = await promise(code, mobile);
            if (!success) {
                trackApi.track('pc_phone_number_operation_result', { action: isBind || isUpdate, result: message });
                return message || '';
            }
            const email = systemApi.getCurrentUser().id;
            const { mobile: phone, mobileArea } = accountApi.doGetMobileAndArea(mobile);
            if (isBind || isUpdate) {
                SiriusModal.success({
                    title: getIn18Text('SHOUJIHAOBANGDING'),
                    content: `账号${email}和手机号(+${mobileArea})${phone}绑定成功。`,
                    hideCancel: true,
                });
            }
            else {
                SiriusModal.success({
                    title: getIn18Text('SHOUJIHAOJIEBANG'),
                    content: `账号${email}和手机号(+${mobileArea})${phone}解绑成功。`,
                    hideCancel: true,
                });
            }
            trackApi.track('pc_phone_number_operation_result', { action: isBind || isUpdate, result: true });
        }
        if (from === 'loginAccount') {
            const { success, message } = await accountApi.doBindMobile(code, mobile);
            if (!success) {
                trackApi.track('pc_phone_number_operation_result', { action: isBind, result: message });
                return message || '';
            }
        }
        onSuccess && onSuccess(mobile, code);
        return '';
    };
    const onSendCode = async (phone) => {
        if (from === 'login' || from === 'register') {
            const res = await loginApi.doMobilePreLogin(phone, from === 'register' ? 2 : 1);
            if (typeof res === 'object' && res.errmsg) {
                return res.errmsg;
            }
            if (typeof res === 'string') {
                return res;
            }
            return loginApi.doSendVerifyCode();
        }
        const { message } = await accountApi.doGetVerifyCode(phone, !isBind && !isUpdate);
        return message;
    };
    const onPreLogin = async (phone) => {
        if (from === 'login') {
            return loginApi.doMobilePreLogin(phone);
        }
        if (from === 'register') {
            return loginApi.doMobilePreLogin(phone, 2);
        }
        return undefined;
    };
    const submitTxt = isWebWmEntry && from === 'register' ? submitTxtMap.newRegister : submitTxtMap[from];
    const loadingTxtMap = { register: getIn18Text('CHULIZHONG'), account: '', login: '', loginAccount: '' };
    const loadingTxt = loadingTxtMap[from];
    return (React.createElement(MobileValidateForm, { from: from, hideMobileInput: hideMobileInput, defaultValue: defaultMobile, defaultArea: defaultArea, onSubmit: onSubmit, onPreLogin: onPreLogin, onSendCode: onSendCode, loadingTxt: loadingTxt, submitTxt: submitTxt, toRegister: toRegister, renderSubmitBottom: renderSubmitBottom, disable: registerSuccess && isWebWmEntry }));
};
export default MobileValidate;
